import React, { type ComponentProps, forwardRef } from "react";

import { cn } from "@/lib/helpers/cn";

type BodyProps = {
  children: React.ReactNode;
  className?: string;
} & ComponentProps<"div">;

export const Body = forwardRef<HTMLDivElement, BodyProps>(
  ({ children, className, ...props }: BodyProps, ref) => (
    <div
      className={cn(
        "tw:p-1.5 tw:border tw:border-solid tw:border-fill-quinary tw:justify-between",
        className,
      )}
      ref={ref}
      {...props}
    >
      {children}
    </div>
  ),
);

Body.displayName = "Schedule.Body";
